import { Amplify } from "aws-amplify";
import outputs from "../amplify_outputs.json";

// Validate required configuration
if (!outputs?.auth?.user_pool_id || !outputs?.auth?.user_pool_client_id) {
  console.error(
    "Amplify config error: user_pool_id or user_pool_client_id missing in amplify_outputs.json"
  );
  throw new Error("Missing required Amplify configuration");
}

// Get environment-specific configuration
// const isLocalDev = import.meta.env.VITE_USE_LOCAL_AUTH === "true";
const apiBaseUrl = import.meta.env.VITE_API_URL || "http://localhost:3000";
const authBypass = import.meta.env.VITE_DEV_AUTH_BYPASS === "true";

// Configure Amplify with the backend outputs
const config = {
  Auth: {
    Cognito: {
      userPoolId: outputs.auth.user_pool_id,
      userPoolClientId: outputs.auth.user_pool_client_id,
      identityPoolId: outputs.auth.identity_pool_id,
      loginWith: {
        email: true,
        // Magic link configuration
        magicLink: true,
      },
    },
  },
  // Add GraphQL API configuration for Amplify Gen 2
  API: {
    GraphQL: {
      endpoint: outputs.data.url,
      region: outputs.data.aws_region || "us-east-1",
      defaultAuthMode: "userPool" as const,
    },
  }, // Add debug logging for local development
  ...(authBypass && { logging: "DEBUG" }),
};

// Only log in development mode to reduce console noise
if (process.env.NODE_ENV === "development") {
  console.log("Amplify config loaded:", config);
  console.log("Environment:", {
    apiBaseUrl,
    authBypass,
  });
}

// Configure Amplify
Amplify.configure(config);

export default config;
